/*
    Create By fanglijuan 2016-10-17
    个人中心管理配置相关服务
*/
'use strict';
angular.module("personalCenterConfigServiceModule", ["createPersonalCenterConfigModule"])
    .factory("personalCenterConfigService", ["$modal", '$q', function($modal, $q) {
        return {
            //添加or修改模块
            addOrEditPersonalCenterConfig: function(personalCenterConfig) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/sysManageMent/personalCenterConfig/service/add/add_tpl.html",
                    windowClass: 'sysManageMent-createPersonalCenterConfig-window',
                    backdrop: false,
                    controller: "createPersonalCenterConfigCtrl",
                    resolve: {
                        personalCenterConfig: function() {
                            return personalCenterConfig;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            }
        };
    }]);
